import React, { useEffect, useState } from "react";
import "./mainuserpage.css";
import dash from "../../../img/undraw_location_tracking_re_n3ok.svg";
import { Fade } from "react-awesome-reveal";
import { Link } from "react-router-dom";
import { isMobile, isTablet, isDesktop } from "react-device-detect";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import { Button, Modal } from "react-bootstrap";
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});
const MainUserpage = () => {
  const colors = ["#0d6efd", "#a31a27", "#198754", "#008aa6"];
  let currentTime = new Date();
  let Time = new Date();
  const [Chosedur, setChosedur] = useState("");
  const [Lat, setLat] = useState();
  const [Lon, setLon] = useState();
  const [Datee, setDate] = useState(currentTime.toLocaleDateString("en-GB"));
  const [Timee, setTimee] = useState(null);
  const [TimeeCheckin, setTimeeCheckin] = useState(null);
  const [TimeeCheckout, setTimeeCheckout] = useState(null);
  const [deviceModel, setDeviceModel] = useState("");
  // const [currentLocation, setCurrentLocation] = useState(null);
  // const [showMapIn, setshowMapIn] = useState(false);
  // const [showMapOut, setshowMapOut] = useState(false);

  // const [showMapBtnChkin, setshowMapBtnChkin] = useState(false);
  // const [showMapBtnChkout, setshowMapBtnChkout] = useState(false);

  // const handleCloseMapIn = () => {
  //   setshowMapIn(false);
  // };
  // const handleCloseMapOut = () => {
  //   setshowMapOut(false);
  // };
  // const handleShowMapIn = () => setshowMapIn(true);
  // const handleShowMapOut = () => setshowMapOut(true);

  // const handleCheckin = () => {
  //   setTimeeCheckin(getFormattedTime());
  //   setshowMapBtnChkin(true);
  // };
  // const handleCheckout = () => {
  //   setTimeeCheckout(getFormattedTime());
  //   setshowMapBtnChkout(true);
  // };

  // const getFormattedTime = () => {
  //   const now = new Date();
  //   let hours = now.getHours();
  //   const minutes = now.getMinutes();
  //   const ampm = hours >= 12 ? "PM" : "AM";
  //   hours = hours % 12 || 12;
  //   return `${hours}:${minutes < 10 ? "0" + minutes : minutes} ${ampm}`;
  // };
  // const getDeviceType = () => {
  //   if (isMobile) return "Mobile";
  //   if (isTablet) return "Tablet";
  //   if (isDesktop) return "Laptop/Desktop";
  //   return "Unknown";
  // };

  // useEffect(() => {
  //   setDeviceModel(getDeviceType());
  //   setTimee(getFormattedTime());
  // }, []);

  // useEffect(() => {
  //   navigator.permissions.query({ name: "geolocation" }).then((result) => {
  //     if (result.state === "granted" || result.state === "prompt") {
  //       navigator.geolocation.getCurrentPosition(
  //         (position) => {
  //           setCurrentLocation({
  //             lat: position.coords.latitude,
  //             lng: position.coords.longitude,
  //           });
  //           setLat(position.coords.latitude);
  //           setLon(position.coords.longitude);
  //         },
  //         (error) => {
  //           alert("تعذر تحديد الموقع: " + error.message);
  //         }
  //       );
  //     } else {
  //       alert("من فضلك قم بتفعيل الوصول إلى موقعك");
  //     }
  //   });
  // }, [currentLocation]);

  return (
    <div className="container">
      <div className="mainadminpage">
        <Fade direction="right">
          <div className="infmy">
            <div className="infoo">
              <h2>تطبيق أعمال حضور وانصراف</h2>
            </div>

            <hr />
            <div className="myf">
              <ul className="footer-links">
                {/* <h2>الملفات</h2>  */}

                <li>
                  <i className="fa-solid fa-chevron-left"></i>{" "}
                  <Link to="/user/mainemployee">
                    <span
                      style={{
                        color: colors[Math.floor(Math.random() * 5) + 1],
                      }}>
                      {" "}
                      إدارة الموظفين
                    </span>
                  </Link>
                  <hr />
                </li>
                <li>
                  <i className="fa-solid fa-chevron-left"></i>{" "}
                  <Link
                    style={{ color: colors[Math.floor(Math.random() * 5) + 1] }}
                    to="/user/hodoradmin">
                    <span
                      style={{
                        color: colors[Math.floor(Math.random() * 5) + 1],
                      }}>
                      {" "}
                      إدارة حضور وانصراف
                    </span>
                  </Link>
                  <hr />
                </li>
                <li>
                  <i className="fa-solid fa-chevron-left"></i>{" "}
                  <Link
                    style={{ color: colors[Math.floor(Math.random() * 5) + 1] }}
                    to="/user/salaryemp">
                    <span
                      style={{
                        color: colors[Math.floor(Math.random() * 5) + 1],
                      }}>
                      {" "}
                      إدارة المرتبات
                    </span>
                  </Link>
                  <hr />
                </li>
                <li>
                  <i className="fa-solid fa-chevron-left"></i>{" "}
                  <Link
                    style={{ color: colors[Math.floor(Math.random() * 5) + 1] }}
                    to="/user/managerequest">
                    <span
                      style={{
                        color: colors[Math.floor(Math.random() * 5) + 1],
                      }}>
                      {" "}
                      إدارة طلبات إدارية
                    </span>
                  </Link>
                  <hr />
                </li>
                <li>
                  <i className="fa-solid fa-chevron-left"></i>{" "}
                  <Link
                    style={{ color: colors[Math.floor(Math.random() * 5) + 1] }}
                    to="/user/manageholiday">
                    <span
                      style={{
                        color: colors[Math.floor(Math.random() * 5) + 1],
                      }}>
                      {" "}
                      اجازات موظف
                    </span>
                  </Link>
                  <hr />
                </li>
                <li>
                  <i className="fa-solid fa-chevron-left"></i>{" "}
                  <Link
                    style={{ color: colors[Math.floor(Math.random() * 5) + 1] }}
                    to="/user/managerequest">
                    <span
                      style={{
                        color: colors[Math.floor(Math.random() * 5) + 1],
                      }}>
                      {" "}
                      طلب إداري
                    </span>
                  </Link>
                  <hr />
                </li>
                {/* <li>
                  <i className="fa-solid fa-chevron-left"></i>{" "}
                  <Link
                    style={{ color: colors[Math.floor(Math.random() * 5) + 1] }}
                    to="/user/hodoremp">
                    <span
                      style={{
                        color: colors[Math.floor(Math.random() * 5) + 1],
                      }}>
                      {" "}
                      اثبات حضور وانصراف للمسؤل
                    </span>
                  </Link>
                  <hr />
                </li> */}

                <li>
                  <i className="fa-solid fa-arrow-up-right-from-square"></i>{" "}
                  <Link to="/user/howwork" style={{ color: "#40485b" }}>
                    <span
                      style={{
                        color: colors[Math.floor(Math.random() * 5) + 1],
                      }}>
                      {" "}
                      فيديوهات شرح كيفية الأستخدام
                    </span>
                  </Link>
                  <hr />
                </li>
                <li>
                  <i className="fa-solid fa-arrow-up-right-from-square"></i>{" "}
                  <Link to="/user/sub" style={{ color: "#40485b" }}>
                    <span
                      style={{
                        color: colors[Math.floor(Math.random() * 5) + 1],
                      }}>
                      {" "}
                      الاشتراك
                    </span>
                  </Link>
                  <hr />
                </li>
              </ul>
              {/* <ul className="footer-links">
          <h2>أضافات</h2> 
                    <li >
                      <i className="fa-solid fa-chevron-left"></i>
                      <span onClick={handleShowMain}>حساب رئيسي</span>
                    </li>
                    <li >
                      <i className="fa-solid fa-chevron-left"></i>
                      <span onClick={handleShowSub}>حساب فرعي</span>
                    </li>
          </ul> */}
            </div>
          </div>
        </Fade>

        <div className="imges">
          <img src={dash} alt="" />
          <a href="/user/hodoremp" className="checkin-mgr">
            اثبات حضور وانصراف <i className="fa-solid fa-user-check"></i>
          </a>
        </div>
      </div>
    </div>
  );
};

export default MainUserpage;
